import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  resultsContainer: {
    marginTop: theme.spacing(4)
  }
});

export default makeStyles(styles);
